export default "__VITE_ASSET__ramGE8H2__"